import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  Box,
  Divider,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import Slider from "@mui/material/Slider";
import { useEffect, useState } from "react";
import useColors from "../../../../api/hooks/useColors";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";
import { getEnvStorageKey } from "../../../../utils/environment";

const FTEDailyCostKey = getEnvStorageKey("FTEDailyCost");
const PriorityWeights = ({ open, handleClose }) => {
  const [expandImpact, setExpandImpact] = useState(false);
  const [expandCost, setExpandCost] = useState(false);
  const [values, setValues] = useState({
    complexity: 50,
    impact: 50,
    cost: 50,
    uxEffect: 50,
    effort: 50,
    duration: 50,
  });
  const [valuesImpact, setValuesImpact] = useState({
    Exploitable: 50,
    InternetFacing: 50,
    Likelihood: 50,
    Probability: 50,
    Severity: 50,
  });
  const [FTEDailyCost, setFTEDailyCost] = useState(0);

  const handleSave = () => {
    localStorage.setItem(FTEDailyCostKey, FTEDailyCost.toString());
  };

  useEffect(() => {
    const savedFTEDailyCost = Number(localStorage.getItem(FTEDailyCostKey));
    if (savedFTEDailyCost) {
      setFTEDailyCost(savedFTEDailyCost);
    }
  }, []);

  const handleChange = (slider) => (event, newValue) => {
    setValues({ ...values, [slider]: newValue });
  };
  const handleChangeImpact = (slider) => (event, newValue) => {
    setValuesImpact({ ...valuesImpact, [slider]: newValue });
  };
  const colors = useColors();

  const inputSx = {
    "& input[type=number]": {
      "-moz-appearance": "textfield",
      "text-align": "center",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
    >
      <Box
        sx={{
          width: 500,
          maxHeight: 700,
          height: 700,
          pl: 3,
          pr: 3,
          bgcolor: "background.paper",
          margin: "auto",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          boxShadow: 24,
          overflowY: "scroll",
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            position: "sticky",
            top: 0,
            zIndex: 1,
            backgroundColor: "#fff",
            pt: "5%",
          }}
          id="modal-modal-title"
        >
          <Typography
            variant="subtitle1"
            gutterBottom
            sx={{ color: colors.primary_main }}
          >
            Priority Weights
          </Typography>
          <Typography variant="body2" gutterBottom>
            Adjust the importance of each category to tailor remediation efforts
            to your needs
          </Typography>
        </Box>
        <Box sx={{ paddingTop: "2%" }}>
          <Divider />
          {[
            "complexity",
            "impact",
            "cost",
            "uxEffect",
            "effort",
            "duration",
          ].map((slider) => (
            <Box key={slider} sx={{ marginBottom: 2 }}>
              <Box display={"flex"} justifyContent={"space-between"}>
                <Typography
                  id={`${slider}-slider`}
                  gutterBottom
                  sx={{ color: colors.primary_main, textTransform: "none" }}
                  variant="overline"
                >
                  {slider.charAt(0).toUpperCase() + slider.slice(1)}
                </Typography>
                {slider === "cost" && (
                  <Box
                    sx={{ cursor: "pointer" }}
                    onClick={() => setExpandCost((prv) => !prv)}
                  >
                    {expandCost ? (
                      <KeyboardArrowUpIcon />
                    ) : (
                      <KeyboardArrowDownIcon />
                    )}
                  </Box>
                )}
                {slider === "impact" && (
                  <Box
                    sx={{ cursor: "pointer" }}
                    onClick={() => setExpandImpact((prv) => !prv)}
                  >
                    {expandImpact ? (
                      <KeyboardArrowUpIcon />
                    ) : (
                      <KeyboardArrowDownIcon />
                    )}
                  </Box>
                )}
              </Box>
              <Stack
                spacing={2}
                gap={2}
                direction="row"
                sx={{ mb: 1 }}
                alignItems="center"
              >
                0
                <Slider
                  value={values[slider]}
                  onChange={handleChange(slider)}
                  aria-labelledby={`${slider}-slider`}
                  valueLabelDisplay="on"
                  size="small"
                  step={1}
                  min={0}
                  max={100}
                  sx={{ color: colors.primary_main }}
                />
                100
              </Stack>
              {expandImpact && slider === "impact" && (
                <>
                  {[
                    "Exploitable",
                    "InternetFacing",
                    "Probability",
                    "Likelihood",
                    "Severity",
                  ].map((slider) => (
                    <Box
                      key={slider}
                      sx={{
                        marginBottom: 2,
                        marginLeft: "5%",
                        marginRight: "5%",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        id={`${slider}-slider`}
                        gutterBottom
                        sx={{
                          color: colors.primary_light,
                          textTransform: "none",
                        }}
                        variant="overline"
                      >
                        {slider.charAt(0).toUpperCase() + slider.slice(1)}
                      </Typography>
                      <Stack
                        spacing={2}
                        gap={2}
                        direction="row"
                        sx={{ mb: 1 }}
                        alignItems="center"
                      >
                        0
                        <Slider
                          value={valuesImpact[slider]}
                          onChange={handleChangeImpact(slider)}
                          aria-labelledby={`${slider}-slider`}
                          valueLabelDisplay="on"
                          size="small"
                          step={1}
                          min={0}
                          max={100}
                          sx={{ color: colors.primary_light }}
                        />
                        100
                      </Stack>
                    </Box>
                  ))}
                </>
              )}
              {expandCost && slider === "cost" && (
                <>
                  <Box
                    key={slider}
                    sx={{
                      marginBottom: 2,
                      marginLeft: "5%",
                      marginRight: "5%",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        textAlign: "left",
                      }}
                    >
                      <Typography
                        id={`${slider}-slider`}
                        gutterBottom
                        sx={{
                          color: colors.primary_light,
                          textTransform: "none",
                        }}
                        variant="overline"
                      >
                        FTE Daily Cost
                      </Typography>
                      {
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 0,
                            width: "90%x",
                          }}
                        >
                          <Box>$</Box>
                          <TextField
                            InputProps={{
                              style: {
                                fontSize: 14,
                                height: "100%",
                              },
                            }}
                            variant="standard"
                            type="number"
                            sx={{ ...inputSx }}
                            fullWidth
                            value={FTEDailyCost}
                            onChange={(e) => setFTEDailyCost(e.target.value)}
                          ></TextField>
                        </div>
                      }
                    </Box>
                  </Box>
                </>
              )}
              <Divider />
            </Box>
          ))}
        </Box>
        <Box sx={{ textAlign: "center" }}>
          <PrimaryButton
            onClick={() => {
              handleClose();
              handleSave();
            }}
          >
            <Typography variant="caption">Done</Typography>
          </PrimaryButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default PriorityWeights;
